import React, { Component } from 'react';
import { Popover, Button, TextField, Box, Typography, Container } from '@material-ui/core';

export class ConstantPopover extends Component {

    styles = {
        button: {
            marginLeft: 10,
            marginRight: 10
        },
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 20,
            marginBottom: 10
        }
    };

    state = {
        name: "",
        value: "",
        description: ""
    }

    componentDidUpdate(prevProps) {
        if (!this.props.isOpen)
            return;

        if (prevProps.isOpen !== this.props.isOpen || prevProps.constantName !== this.props.constantName || prevProps.constantValue !== this.props.constantValue || prevProps.constantDescription !== this.props.constantDescription) {
            this.setState({
                name: this.props.constantName ?? "",
                value: this.props.constantValue ?? "",
                description: this.props.constantDescription ?? ""
            });
        }
    }

    _nameFieldChanged = (event) => {
        const nextName = event.target.value ? event.target.value.slice(0, 40) : "";
        this.setState({name: nextName});
    }

    _valueFieldChanged = (event) => {
        this.setState({value: event.target.value ?? ""});
    }

    _descriptionFieldChanged = (event) => {
        this.setState({description: event.target.value ?? ""});
    }

    _resetFields = () => {
        this.setState({name: "", value: "", description: ""});
    }

    _okButtonPressed = () => {
        this.props.okCallback(this.state.name, this.state.value, this.state.description);
        this._resetFields();
    }

    _cancelButtonPressed = () => {
        this.props.cancelCallback();
        this._resetFields();
    }

    render() {
        let maxWidth = window.innerWidth * 0.5;
        if (maxWidth > 700)
            maxWidth = 700;

        const trimmedName = this.state.name.trim();

        return (
            <Popover open={this.props.isOpen}
                anchorReference="anchorPosition"
                anchorPosition={{left: window.innerWidth / 2, top: window.innerHeight / 2}}
                transformOrigin={{vertical: 'center', horizontal: 'center'}}>

                <Box style={{margin: 20, width: maxWidth}}>
                    <Typography variant="subtitle1" style={{fontWeight: 'bold'}}>{this.props.title ?? 'Add Constant'}</Typography>
                    <div style={{marginTop: 20}} />

                    <TextField label="Constant Name"
                               autoFocus
                               value={this.state.name}
                               onChange={this._nameFieldChanged}
                               variant="outlined"
                               fullWidth={true}
                               inputProps={{maxLength: 40}}
                               helperText={`${this.state.name.length}/40`}
                               InputLabelProps={{shrink: true}} />

                    <div style={{marginTop: 15}} />

                    <TextField label="Constant Value"
                               value={this.state.value}
                               onChange={this._valueFieldChanged}
                               variant="outlined"
                               fullWidth={true}
                               InputLabelProps={{shrink: true}} />

                    <div style={{marginTop: 15}} />

                    <TextField label="Constant Description"
                               value={this.state.description}
                               onChange={this._descriptionFieldChanged}
                               variant="outlined"
                               fullWidth={true}
                               inputProps={{maxLength: 256}}
                               helperText={`${this.state.description.length}/256`}
                               InputLabelProps={{shrink: true}} />

                    <Typography variant="caption" style={{display: 'block', marginTop: 5, color: 'gray', fontStyle: 'italic'}}>
                        Constant Value must be a text string in double quotes or a number
                    </Typography>

                    <Container style={this.styles.container}>
                        <Button onClick={this._okButtonPressed} disabled={!trimmedName} color="primary" variant="outlined" style={this.styles.button}>{this.props.okLabel ?? 'OK'}</Button>
                        <Button onClick={this._cancelButtonPressed} variant="outlined" style={this.styles.button}>Cancel</Button>
                    </Container>
                </Box>
            </Popover>
        );
    }
}
